import { useEffect, useState } from "react";
import { formatarData } from "../../../components/utils/functions";
import MobileList from "../../ui/MobileList";
import MobileListItem from "../../ui/MobileListItem";
import MobileSkeleton from "../../ui/MobileSkeleton";
import MobileEmpty from "../../ui/MobileEmpty";
import MobileError from "../../ui/MobileError";
import { useHolidaysSearch } from "./useHolidaysSearch";
import { MobileCreateHolidaySheet, MobileHolidayDetailSheet } from "./MobileHolidaySheets";

function holidaySubtitle(holiday) {
  const formatted = formatarData(holiday?.date);
  return formatted ?? "";
}

export default function MobileHolidaysList({ user }) {
  const { holidays, loading, error, search, refresh } = useHolidaysSearch(user);
  const [createOpen, setCreateOpen] = useState(false);
  const [selectedHoliday, setSelectedHoliday] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  useEffect(() => {
    setHasSearched(true);
    search();
  }, [search]);

  const handleSearch = () => {
    setHasSearched(true);
    search();
  };

  const openDetail = (holiday) => {
    setSelectedHoliday(holiday);
    setDetailOpen(true);
  };

  const closeDetail = () => {
    setDetailOpen(false);
    setSelectedHoliday(null);
  };

  const handleCreated = () => {
    setCreateOpen(false);
    setHasSearched(true);
    refresh();
  };

  const handleHolidayChanged = () => {
    closeDetail();
    refresh();
  };

  return (
    <div className="flex flex-col">
      <div className="flex items-center gap-2 border-b border-primary/30 bg-mgs-bg px-4 py-2">
        <button
          type="button"
          onClick={() => setCreateOpen(true)}
          className="inline-flex min-h-[44px] items-center justify-center rounded-lg bg-primary px-3 text-sm font-medium text-mgs-bg hover:bg-[#b47c06]"
        >
          Cadastrar feriado
        </button>
        <button
          type="button"
          onClick={handleSearch}
          className="inline-flex min-h-[44px] items-center justify-center rounded-lg bg-primary px-3 text-sm font-medium text-mgs-bg hover:bg-[#b47c06]"
        >
          Pesquisar feriados
        </button>
        <button
          type="button"
          onClick={() => {
            setHasSearched(true);
            refresh();
          }}
          className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-primary/50 px-3 text-sm font-medium text-laranjinha/80 hover:bg-monao"
        >
          Atualizar
        </button>
      </div>

      {loading ? (
        <div aria-label="Carregando feriados" role="status">
          <MobileSkeleton lines={5} />
        </div>
      ) : error ? (
        <MobileError
          message={error.message ?? "Erro ao buscar feriados."}
          onRetry={refresh}
        />
      ) : hasSearched && holidays.length === 0 ? (
        <MobileEmpty
          title="Nenhum feriado encontrado"
          message="Toque em Pesquisar feriados para carregar a lista."
        />
      ) : holidays.length > 0 ? (
        <MobileList>
          {holidays.map((item) => (
            <MobileListItem
              key={item._id}
              title={item.name ?? "Sem nome"}
              subtitle={holidaySubtitle(item)}
              onClick={() => openDetail(item)}
            />
          ))}
        </MobileList>
      ) : null}

      <MobileCreateHolidaySheet
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        user={user}
        onCreated={handleCreated}
      />

      <MobileHolidayDetailSheet
        open={detailOpen}
        onClose={closeDetail}
        holiday={selectedHoliday}
        user={user}
        onChanged={handleHolidayChanged}
      />
    </div>
  );
}
